import React from "react"
import clsx from "clsx"
import { collabs } from "@staticdata/lookbook-static-data"
import ProductSwiper from "@components/Home/Carousel/ProductSwiper"

const CollabMenu = ({ isOpen, handleCollabMenu }) => {

	return (
		<React.Fragment>
			<div
				className={clsx('w-auto lg:w-full bg-white absolute z-[49]', isOpen ? 'absolute' : 'hidden')}
				onMouseLeave={() => handleCollabMenu(false)}
			>
				<div className={clsx('relative max-container px-6 py-6')}>
					<ProductSwiper 
						products={collabs}
						spaceBetween={16}
						slidesPerView={4}
						cardType="collab card"
						cardStyles="relative w-full h-full overflow-hidden cursor-pointer"
						breakpoints={{
							500: {
								spaceBetween: 8,
								slidesPerView: 3.5
							},
							640: {
								spaceBetween: 8,
								slidesPerView: 3.5
							},
							1024: {
								spaceBetween: 16,
								slidesPerView: 4
							}
						}}
						pagination
						loop
					/>
					
					{/* {collabs.map((item, index) => (
						<div key={`lbcard-thumb-${index}`} className="pt-6 lg:pt-0 justify-center lg:justify-start">
							<CollabCard
								data={item}
								className=
								showButton
							/>
						</div>
					))} */}
				</div>
			</div>
		</React.Fragment>
	)
}

export default CollabMenu
